import { Link } from '@tanstack/react-router';

import { Badge } from '@/components/ui/badge';

import { usePromptOverrides } from './usePromptOverride';

export function PromptsPage() {
  const { data, isLoading, error } = usePromptOverrides();
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-semibold tracking-tight">Prompts</h2>
        <p className="text-sm text-muted-foreground">
          Prompts staff can change without a deploy. A saved prompt replaces the
          one in code until it is reset. A prompt joins this list when a
          developer registers it in the backend.
        </p>
      </div>
      {isLoading ? (
        <p className="text-sm text-muted-foreground">Loading…</p>
      ) : error ? (
        <p className="text-sm text-destructive">{error.message}</p>
      ) : (
        <ul className="divide-y rounded-md border">
          {data?.map((prompt) => (
            <li key={prompt.slug}>
              <Link
                to="/prompts/$slug"
                params={{ slug: prompt.slug }}
                className="flex items-center justify-between gap-4 px-4 py-3 hover:bg-accent"
              >
                <div className="space-y-0.5">
                  <p className="font-medium">{prompt.title}</p>
                  <p className="text-sm text-muted-foreground">
                    {prompt.description}
                  </p>
                </div>
                <Badge variant={prompt.is_overridden ? 'default' : 'secondary'}>
                  {prompt.is_overridden ? 'Edited' : 'Default'}
                </Badge>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
